module.exports = __webpack_public_path__ + "img/farm_Kenya.daac5a24.jpg";